import { tns } from "../../../thirdparty/tinyslider/tinyslider.js";

class MainScroller{
    constructor(){
        this.homeScroller = document.querySelector('.homeScroller');
        this.homepageSlider = null;

        this.setFocus = this.setFocus.bind(this);
        this.focusOnActiveSlide = this.focusOnActiveSlide.bind(this);
        this.updateTabIndex = this.updateTabIndex.bind(this);
    }

    init() {
        const pauseIcon = "<svg class='textGray' width='30' height='30' focusable='false'><title>Pause Scrolling</title> <use href='/icons/iconLibrary.svg#svgIcon-pause'></use> </svg>";
        const playIcon = "<svg class='textGray rotate90' width='30' height='30' focusable='false'><title>Resume Scrolling</title> <use href='/icons/iconLibrary.svg#svgIcon-arrowSolid'></use> </svg>";
        this.homepageSlider = new tns({
            container: document.querySelector('.homeScroller'),
            lazyload: true,
            controls: false,
            nav: true,
            navPosition: "bottom",
            loop: true,
            autoplay: true,
            speed: 1000,
            autoplayTimeout: 5500,
            autoplayHoverPause: true,
            autoplayPosition: "top",
            autoplayButton: "#pausePlayBtn",
            autoplayText: [
                playIcon,
                pauseIcon
            ]
        });

        this.homepageSlider.events.on('transitionStart', this.updateTabIndex);

        const banner = document.querySelector(".homepageBanner");
        const sliderPages = Array.from(banner.querySelectorAll(".tns-nav button"));
        for(const btn of sliderPages){
            btn.addEventListener("click", this.focusOnActiveSlide);
        }
        
        banner.classList.remove("invisible");
    }

    updateTabIndex(){
        // set the active slide button to tabindex 0 and the rest to -1 so they cannot be tabbed to
        const slides = Array.from(this.homeScroller.querySelectorAll(".tns-item"));
        for(const slide of slides){
            slide.querySelector("a").setAttribute("tabindex", "-1");
        }
        const activeLink = this.homeScroller.querySelector(".tns-slide-active").querySelector("a");
        activeLink.setAttribute("tabindex", "0");
    }

    focusOnActiveSlide(e){
        e.preventDefault();
        this.homepageSlider.events.on('transitionEnd', this.setFocus);
    }

    setFocus() {
        const activeSlideBtn = document.querySelector(".tns-slide-active a");
        activeSlideBtn.focus();
        this.homepageSlider.events.off('transitionEnd', this.setFocus);
    }
}

export default new MainScroller();